import React from 'react';
import { isDirty } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { messages as acctSetMsgs } from './AccountSettings.i18n';

export const renderUserName = (username) => () => (
  <div aria-labelledby="usernameLabel username" tabIndex="0">
    <label className="control-label" id="usernameLabel">
      <FormattedMessage { ...acctSetMsgs.accountSettings.label.username } />
    </label>&nbsp;
    <span className="form-control-static" id="username">
      { username }
    </span>
    <div className="spacer small"></div>
  </div>
);

export const renderStateMessage = (stateMessage, className) => () => (
  <p className={className} data-qa-item="stateMessage" tabIndex="0">
    <FormattedMessage { ...stateMessage } />
  </p>
);

export const isContactFormDirty = (formState) =>
  isDirty('contactform')(formState);

export const renderButton = (config) => (
  <a role="button" className="btn btn-lg btn-default bottom-margin"
    tabIndex="0"
    data-qa-item={config.qaTag}
    key={config.key}
    style={{ marginRight: '3px' }}
    aria-describedby={config.ariaDescribedby}
    onClick={config.onClick}
  >
    <FormattedMessage { ...config.label } />
  </a>
);
